import qs from 'qs';
import {loadStripe} from '@stripe/stripe-js';
import moment from 'moment';
import {connect} from 'react-redux';
import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import {withRouter} from 'react-router-dom';
import ContactOwner from '../ContactOwner';
import Loading from '../../Base/Loading';
import ChangeFavorites from '../ChangeFavorites';
import * as AppConst from '../../../constants/App';
import {createOrder} from '../../../actions/Orders';
import {showAuthModal} from '../../../actions/User';
import * as SearchConst from '../../../constants/Search';
import CustomDatepickerInput from '../../Base/CustomDatepickerInput';
import {addCalendars, booking, bookingCalculate, getCalendars} from '../../../actions/ObjectPage';
import {getCalculationResult, prepareCalculationMessage} from "./CalculationUtils";
import {PROPERTY_PART} from "../../../constants/RoutePaths";

let stripe = undefined

const defaultProps = {
    showAuthModal: isShowAuthModal => {
    },
    createOrder: ordersCreateCommand => {
    },
    addCalendars: (objectId, search) => {
    },
    bookingCalculate: (objectId, rentCalculationCommand) => {
    }
};

let oldDateEndMoment;
let oldDateStartMoment;
let crutchDayStart = 7;

class BookIt extends Component {
    state = {
        isShowHint: true,
        isNeedCrutch: false,
        isNeedExcludeDates: true,
        isShowEmailSendModal: false,
        reservationErrorMessage: '',
        isShowSelectGuestsOptions: false,
        dateStart: undefined,
        dateEnd: undefined,
        guestCount: 0,
        cancellationBookingFunction: undefined
    };

    componentDidMount() {
        this.getCalendars(moment());
        this.handleHometogo();
        this.initialDateRange();
    }

    componentWillReceiveProps({isNeedCalculate}) {
        if (isNeedCalculate) {
            this.bookingCalculate();
        }
    }

    componentDidUpdate(prevProps, prevStates) {
        // Костыль для смены языка в календаре.
        if (prevProps.code !== undefined && prevProps.code !== this.props.code) {
            if (oldDateStartMoment === undefined && oldDateEndMoment === undefined) {
                const {dateStartMoment, dateEndMoment} = this.props;
                oldDateStartMoment = dateStartMoment;
                oldDateEndMoment = dateEndMoment;
            }

            this.setState({
                isNeedCrutch: true,
                isNeedExcludeDates: false
            });
        }

        if (this.state.isNeedCrutch) {
            const $ = window.jQuery;
            [...document.getElementsByClassName('crutch-day')].forEach((elem, index) => {
                if (index > crutchDayStart && index < (crutchDayStart + 3)) {
                    $(elem).trigger('click');
                }
            });
            crutchDayStart++;

            this.setState({dateStart: oldDateStartMoment});
            this.setState({dateEnd: oldDateEndMoment});

            oldDateStartMoment = undefined;
            oldDateEndMoment = undefined;

            this.setState({
                isNeedCrutch: false,
                isNeedExcludeDates: true
            });
        }
        // Конец костыля.

        // должны быть заданы три параметры и хотя бы один из параметров должен был поменяться
        if (
            this.state.dateStart !== undefined &&
            this.state.dateEnd !== undefined &&
            this.state.guestCount !== undefined &&
            (this.state.dateStart !== prevStates.dateStart ||
                this.state.dateEnd !== prevStates.dateEnd ||
                this.state.guestCount !== prevStates.guestCount)
        ) {
            this.bookingCalculate();
        }
    }

    getCalendars = (startDate, isAdd) => {
        const {getCalendars, objectPage, addCalendars} = this.props;
        const calendarSearchCommand = {};
        calendarSearchCommand.startDate = startDate.format(AppConst.DATE_FORMAT);
        calendarSearchCommand.endDate = startDate.add(1, 'y').format(AppConst.DATE_FORMAT);

        if (isAdd) {
            addCalendars(objectPage.currentObject.id, calendarSearchCommand);
        } else {
            getCalendars(objectPage.currentObject.id, calendarSearchCommand);
        }
    };

    initialDateRange = () => {
        const {location} = this.props;
        const params = qs.parse(location.search.substring(1));

        const dateStart = params[SearchConst.REQUEST_PARAMS_NAMES.DATE_START];
        if (dateStart !== undefined) {
            this.setState({dateStart: moment(dateStart, AppConst.DATE_FORMAT)});
        }

        const dateEnd = params[SearchConst.REQUEST_PARAMS_NAMES.DATE_END];
        if (dateEnd !== undefined) {
            this.setState({dateEnd: moment(dateEnd, AppConst.DATE_FORMAT)});
        }

        if (dateStart !== undefined && dateEnd !== undefined) {
            this.setState({
                isShowHint: false
            });
        }
    };

    handleHometogo = () => {
        const params = qs.parse(window.location.search.substring(1));

        const {dateStart, dateEnd, guestCount} = params;
        if (dateStart != null && dateEnd != null && guestCount != null) {
            this.setState({dateStart: moment(dateStart, AppConst.DATE_FORMAT)});
            this.setState({dateEnd: moment(dateEnd, AppConst.DATE_FORMAT)});
            this.setState({guestCount: parseInt(guestCount, 10)})
        }
    };

    handleRangeDatesChange(date) {
        if (!date.isBefore(moment().subtract(1, 'days'))) {
            let {dateStart, dateEnd} = this.state;

            let isShowHint = true;
            if (dateStart === undefined) {
                this.setState({dateStart: date});
            } else if (dateEnd === undefined) {
                if (date.isBefore(dateStart)) {
                    this.setState({dateStart: date});
                    this.setState({dateEnd: moment(dateStart, AppConst.DATE_FORMAT)});
                } else {
                    this.setState({dateEnd: date});
                }
                isShowHint = false;
            } else {
                this.setState({dateStart: undefined, dateEnd: undefined});
            }

            this.setState({
                isShowHint: isShowHint
            });
        }
    }

    handleDateStartChange = date => {
        if (!date.isBefore(moment().subtract(1, 'days'))) {
            let dateEndMoment = this.state.dateEnd;

            if (dateEndMoment === undefined || date.isSameOrBefore(dateEndMoment)) {
                this.setState({dateStart: date})
                if (dateEndMoment !== undefined) {
                    this.setState({
                        isShowHint: false
                    });
                }
            }
        }
    };

    handleDateEndChange = date => {
        if (!date.isBefore(moment().subtract(1, 'days'))) {
            let dateStartMoment = this.state.dateStart;

            if (dateStartMoment === undefined || date.isSameOrAfter(dateStartMoment)) {
                this.setState({dateEnd: date})
                if (dateStartMoment !== undefined) {
                    this.setState({
                        isShowHint: false
                    });
                }
            }
        }
    };

    handleCountGuestsChange = e => {
        let newValue = parseInt(e.target.value, 10);
        this.setState({guestCount: newValue});
    };

    handleReservationClick(event) {
        event.preventDefault();
        const i18n = this.props.i18n;

        if (this.props.currentUser.accessToken === null) {
            this.props.showAuthModal(true);

            return;
        }

        let reservationErrorMessage = '';
        if (this.state.countGuest === 0) {
            reservationErrorMessage = i18n['objectPage.countGuestsErrorMessage'];
        } else if (this.state.dateStart === undefined) {
            reservationErrorMessage = i18n['objectPage.selectTheArrivalDate'];
        } else if (this.state.dateEnd === undefined) {
            reservationErrorMessage = i18n['objectPage.selectDepartureDate'];
        } else {
            this.props.booking(
                this.props.objectPage.currentObject.id,
                {
                    countGuests: this.state.guestCount,
                    dateStart: this.state.dateStart.format(AppConst.DATE_FORMAT),
                    dateEnd: this.state.dateEnd.format(AppConst.DATE_FORMAT),
                }
            ).then(sessionId=>{
                stripe.redirectToCheckout({
                    sessionId: sessionId
                })
            });
        }

        this.setState({
            reservationErrorMessage: reservationErrorMessage
        })
    }

    bookingCalculate = () => {
        if (
            this.state.dateStart === undefined ||
            this.state.dateEnd === undefined ||
            this.state.guestCount === undefined) {
            return;
        }

        let getCancelSource = (source) => {
            this.setState({cancellationBookingFunction: source});
        };

        if (this.state.cancellationBookingFunction !== undefined) {
            this.state.cancellationBookingFunction.cancel();
            this.setState({cancellationBookingFunction: undefined});
        }
        this.props.bookingCalculate(
            this.props.objectPage.currentObject.id,
            {
                countGuests: this.state.guestCount,
                dateStart: this.state.dateStart.format(AppConst.DATE_FORMAT),
                dateEnd: this.state.dateEnd.format(AppConst.DATE_FORMAT),
            },
            getCancelSource
        )
    };

    getCalculationResult() {
        const {isShowCalculationResult} = this.props;

        if (isShowCalculationResult) {
            return getCalculationResult(this.state.dateStart, this.state.dateEnd, this.props.calculationResult, this.props.i18n);
        }
    }

    toggleSelectGuestsOptions = () => {
        this.setState(prevState => ({
            isShowSelectGuestsOptions: !prevState.isShowSelectGuestsOptions
        }))
    };

    static getLoadingStyle() {
        let width = 0;
        let height = 0;
        const elements = document.getElementsByClassName('book-it_datepicker');
        if (elements.length > 0) {
            width = elements[0].offsetWidth;
            height = elements[0].offsetHeight;
        }

        return {
            marginLeft: 'auto',
            width: `${width}px`,
            marginRight: 'auto',
            height: `${height}px`,
            marginBottom: `-${height}px`
        };
    }

    getExcludeDates = () => {
        const {days} = this.props;
        let excludeDates = [];

        days.forEach(day => {
            if (day.blocked) {
                excludeDates.push(moment(day.date, AppConst.CALENDAR_DATE_FORMAT))
            }
        });
        return excludeDates;
    };

    handleMonthChange = date => {
        const {calendarsEnd} = this.props;
        const calendarsEndMoment = moment(calendarsEnd, AppConst.CALENDAR_DATE_FORMAT);

        if (
            date.year() > calendarsEndMoment.year() ||
            (date.year() === calendarsEndMoment.year() && date.month() >= calendarsEndMoment.month())
        ) {
            this.getCalendars(calendarsEndMoment.add(1, 'd'), true);
        }
    };

    getGuestOptions = () => {
        const {
            objectPage: {
                currentObject: {
                    props: {
                        countGuest
                    }
                }
            }
        } = this.props;

        let values = [];
        for (let i = 1; i <= countGuest; i++) {
            if (i < 16) {
                values.push(<li key={i} value={i} onClick={this.handleCountGuestsChange}>{i}</li>);
            } else if (i === 16) {
                values.push(<li key={i} value={i} onClick={this.handleCountGuestsChange}>{i}+</li>);
            }
        }

        return (
            <ul>
                {values.map(elem => elem)}
            </ul>
        );
    };

    render() {
        const {
            i18n,
            code,
            errorMessage,
            isShowCalendarLoading
        } = this.props;


        if (stripe === undefined && this.props.stripePublicKey !== undefined) {
            loadStripe(this.props.stripePublicKey).then(r=>{
                stripe = r
            })
        }

        let dateStartMoment = this.state.dateStart;
        let dateEndMoment = this.state.dateEnd;
        let guestCount = this.state.guestCount;

        return (
            <form>
                <div className="calendar-side">
                    {isShowCalendarLoading && <Loading style={BookIt.getLoadingStyle()}/>}

                    {code !== undefined && <DatePicker
                        inline
                        selectsEnd
                        selectsStart
                        locale={code}
                        endDate={dateEndMoment}
                        startDate={dateStartMoment}
                        onMonthChange={this.handleMonthChange}
                        calendarClassName="book-it_datepicker"
                        onChange={::this.handleRangeDatesChange}
                        excludeDates={this.state.isNeedExcludeDates ? this.getExcludeDates() : []}
                        dayClassName={date => date.isBefore(moment().subtract(1, 'days')) ?
                            'crutch-day react-datepicker__day--disabled' :
                            date.isSame(dateStartMoment) ?
                                'crutch-day selecting-range-start' :
                                'crutch-day'}
                    />}
                </div>

                <div className="sidebar-dates">
                    <div className="flex">
                        <div className="to-date">
                            {code !== undefined && <DatePicker
                                locale={code}
                                selected={dateStartMoment}
                                openToDate={dateStartMoment === undefined ? dateEndMoment : undefined}
                                disabled={isShowCalendarLoading}
                                dateFormat={AppConst.DATE_FORMAT}
                                onChange={this.handleDateStartChange}
                                excludeDates={this.getExcludeDates()}
                                popperClassName="book-it-sidebar_datepicker"
                                dayClassName={date => date.isBefore(moment().subtract(1, 'days')) ?
                                    'react-datepicker__day--disabled' :
                                    date.isSame(dateStartMoment) ?
                                        'selecting-range-start' :
                                        undefined}
                                customInput={
                                    <CustomDatepickerInput
                                        customClassName="text-field"
                                        placeholderText={i18n['objectPage.dateStartPlaceholder']}
                                    />
                                }
                            />}
                        </div>
                        <div className="from-date">
                            {code !== undefined && <DatePicker
                                locale={code}
                                selected={dateEndMoment}
                                openToDate={dateEndMoment === undefined ? dateStartMoment : undefined}
                                disabled={isShowCalendarLoading}
                                dateFormat={AppConst.DATE_FORMAT}
                                onChange={this.handleDateEndChange}
                                excludeDates={this.getExcludeDates()}
                                popperClassName="book-it-sidebar_datepicker date-end"
                                dayClassName={date => date.isBefore(moment().subtract(1, 'days')) ?
                                    'react-datepicker__day--disabled' :
                                    date.isSame(dateEndMoment) ?
                                        'selecting-range-start' :
                                        undefined}
                                customInput={
                                    <CustomDatepickerInput
                                        customClassName="text-field"
                                        placeholderText={i18n['objectPage.dateEndPlaceholder']}
                                    />
                                }
                            />}
                        </div>
                        <div className="sd_select-guests" onClick={this.toggleSelectGuestsOptions}>
                            <span>
                                {guestCount !== 0 ? guestCount : i18n['objectPage.guests']}
                            </span>
                            {this.state.isShowSelectGuestsOptions && this.getGuestOptions()}
                        </div>
                    </div>

                    {this.state.isShowHint && <div>
                        <br/><br/>
                        {i18n['objectPage.hint']}
                    </div>}

                    {this.state.reservationErrorMessage.length > 0 && <div>
                        <br/><br/>
                        {prepareCalculationMessage(this.state.reservationErrorMessage, i18n)}
                    </div>}

                    {errorMessage !== undefined && errorMessage !== null && <div>
                        <br/><br/>
                        {prepareCalculationMessage(errorMessage, i18n)}
                    </div>}

                    {this.getCalculationResult()}

                    <button
                        type="submit"
                        className="btn"
                        onClick={::this.handleReservationClick}
                    >
                        {i18n['objectPage.reservation']}
                    </button>
                </div>

                {this.props.currentUser.isAdmin &&
                <div className="button-box">
                    <br/>
                    <a href={`/${PROPERTY_PART}/${this.props.objectPage.currentObject.id}/edit`} className="btn-border">
                        <span>Edit</span>
                    </a>
                </div>
                }

                <div className="button-box">
                    <ChangeFavorites/>
                    <br/>
                    {/*<SendMail />*/}
                    <ContactOwner/>
                </div>
            </form>
        )
    }
}

BookIt.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    objectPage: state.objectPage,
    email: state.user.currentUser.email,
    currentUser: state.user.currentUser,
    days: state.objectPage.calendars.days,
    lastName: state.user.currentUser.lastName,
    code: state.languages.currentLanguage.code,
    firstName: state.user.currentUser.firstName,
    calendarsEnd: state.objectPage.calendars.end,
    isNeedCalculate: state.objectPage.isNeedCalculate,
    calculationResult: state.objectPage.calculationResult,
    bookingRequestParams: state.objectPage.bookingRequestParams,
    errorMessage: state.objectPage.calculationResult.errorMessage,
    isShowCalendarLoading: state.objectPage.isShowCalendarLoading,
    isShowCalculationResult: state.objectPage.isShowCalculationResult,
    stripePublicKey: state.configuration.stripePublicKey,
});

const mapDispatchToProps = {
    createOrder,
    getCalendars,
    addCalendars,
    showAuthModal,
    bookingCalculate,
    booking
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BookIt));



// WEBPACK FOOTER //
// ./src/components/PropertyPage/Rental/BookIt.js